import React from "react";
import CatalogoSimple from "../CatalogoSimple";

// Quién revalida: se elige al capturar un contenedor y en la sección de broker
export default function ListadoRevalidadores() {
  return (
    <CatalogoSimple
      titulo="Quién revalida"
      subtitulo="Opciones que se eligen al capturar un contenedor"
      icono="fas fa-stamp"
      url={process.env.REACT_APP_URL_REVALIDADORES}
    />
  );
}
